<template>
  <el-dialog title="用户协议及隐私政策" :visible.sync="dialogVisible">
    <p>为了更好的保障您的合法权益，请您阅读并同意以下协议
      <a href="https://erp-qd.oss-cn-hangzhou.aliyuncs.com/erp-kmt/%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE_%E5%BF%AB%E9%BA%A6ERP%E8%BD%AF%E4%BB%B6_20240325.pdf" target="_blank">《用户协议》</a>、
      <a href="https://erp-qd.oss-cn-hangzhou.aliyuncs.com/erp-kmt/%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96_%E5%BF%AB%E9%BA%A6ERP%E8%BD%AF%E4%BB%B6_20240326.pdf" target="_blank">《隐私政策》</a>
    </p>
    <div slot="footer" class="dialog-footer">
      <el-button type="text" @click="handleDisagree">不同意</el-button>
      <el-button type="primary" @click="handleAgree">同意</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      dialogVisible: false,
      cb:null
    }
  },
  methods:{
    open  (cb) {
      this.dialogVisible = true
      this.cb = cb
    },
    handleDisagree () {
      this.dialogVisible = false
    },
    handleAgree () {
      this.dialogVisible = false
      this.cb()
    }
  }
}
</script>
<style>
</style>
